import React from 'react';
import DownloadApp from '../components/DownloadApp';

const Home = () => {
  return <DownloadApp />;
};

export default Home;